import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Divider from 'components/FormGroup/Divider';

import * as S from './styles';

const ModalContainer = ({
  children,
  headText,
  isOpen,
  setIsOpen,
  modalWidth,
}) => {
  useEffect(() => {
    const bodyElement = document.body;

    if (isOpen) {
      bodyElement.style.overflowY = 'hidden';
    }

    return () => (bodyElement.style.overflowY = 'scroll');
  }, [isOpen]);

  return (
    <S.Container isOpen={isOpen}>
      <S.Modal modalWidth={modalWidth}>
        <S.CloseModal onClick={() => setIsOpen(false)}>X</S.CloseModal>
        <Divider hasTopSpacing={false} text={headText} />
        <S.Content>{children}</S.Content>
      </S.Modal>
    </S.Container>
  );
};

export default ModalContainer;

ModalContainer.defaultProps = {
  modalWidth: 500,
};

ModalContainer.propTypes = {
  children: PropTypes.node.isRequired,
  headText: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.bool.isRequired,
  modalWidth: PropTypes.number,
};
